export function toClassName(fontFamily) {

  const className = fontFamily.key.toLowerCase().split(' ').join('-') + '-item';

  return className;

}